import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  BankTokenAddMonobankResponseDto,
  BankTokenApi,
  BankTokenCompleteMonobankCommand,
  BankTokenResponseDto,
  BankTokenUpdateCommand,
  MonobankCheckRequestStatusDto,
} from "api";

const bankTokenApi = new BankTokenApi();

export interface BankToken extends BankTokenResponseDto {
  id: string;
}

export interface BankTokenState {
  banks: BankToken[] | null;
}

const initialState: BankTokenState = {
  banks: null,
};

export const getBankIntegrations = createAsyncThunk<
  BankTokenResponseDto[] | null
>("bankIntegrations/getAll", async () => {
  const { data } = await bankTokenApi.apiBankTokenGet();
  return data;
});

export const initMonobankIntegration =
  createAsyncThunk<BankTokenAddMonobankResponseDto>(
    "bankIntegrations/initMonobank",
    async () => {
      const { data } = await bankTokenApi.apiBankTokenMonobankInitPost();
      return data;
    }
  );

export const checkMonobankIntegration = createAsyncThunk<
  MonobankCheckRequestStatusDto,
  string
>("bankIntegrations/checkMonobank", async (bankTokenUid: string) => {
  const { data } = await bankTokenApi.apiBankTokenMonobankStatusBankTokenUidGet(
    bankTokenUid
  );
  return data;
});

export const completeMonobankIntegration = createAsyncThunk<
  BankTokenResponseDto,
  BankTokenCompleteMonobankCommand
>("bankIntegrations/completeMonobank", async ({ bankTokenUid }) => {
  const { data } = await bankTokenApi.apiBankTokenMonobankCompletePost({
    bankTokenUid,
  });
  return data;
});

export const updateBankIntegrationName = createAsyncThunk<
  void,
  BankTokenUpdateCommand
>("bankIntegrations/updateName", async (body: BankTokenUpdateCommand) => {
  await bankTokenApi.apiBankTokenBankTokenUidPut(body.bankTokenUid!, body);
});

export const deleteBankIntegration = createAsyncThunk<void, string>(
  "bankIntegrations/delete",
  async (uid: string) => {
    await bankTokenApi.apiBankTokenBankTokenUidDelete(uid);
  }
);

const bankIntegrationsSlice = createSlice({
  name: "bankIntegrations",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getBankIntegrations.fulfilled, (state, action) => {
      state.banks =
        action.payload?.map((bank) => ({
          ...bank,
          id: bank.bankTokenUid,
        })) || [];
    });
  },
});

export default bankIntegrationsSlice.reducer;
